import { useBreakpoints } from "@/hooks/useBreakpoints/useBreakpoints";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { LogoPropsModel } from "./Logo.model";
import ClemenerBBDODark from "./assets/Clemenger_BBDO_Brandmark_Dark.svg";
import ClemenerBBDODarkMobile from "./assets/Clemenger_BBDO_Brandmark_Dark_Mobile.svg";
import ClemenerBBDOLight from "./assets/Clemenger_BBDO_Brandmark_Light.svg";
import ClemenerBBDOLightMobile from "./assets/Clemenger_BBDO_Brandmark_Light_Mobile.svg";

export default function Logo(props: LogoPropsModel) {
  const { theme, className } = props;
  const { isMobile } = useBreakpoints();

  // Select the appropriate SVG based on theme and screen size
  const logoSrc = (() => {
    if (theme === "Light") {
      return isMobile ? ClemenerBBDOLightMobile : ClemenerBBDOLight;
    } else {
      return isMobile ? ClemenerBBDODarkMobile : ClemenerBBDODark;
    }
  })();

  // Set appropriate alt text
  const altText = "Clemenger BBDO Logo";

  // Set dimensions based on screen size
  const width = isMobile ? 65 : 304;
  const height = isMobile ? 60 : 49;

  return (
    <div
      className={cn(
        "logo absolute top-[22px] right-[12px] z-99 w-auto md:right-[22px]",
        className,
      )}
    >
      <Image
        src={logoSrc}
        alt={altText}
        width={width}
        height={height}
        priority
      />
    </div>
  );
}
